// extracted by mini-css-extract-plugin
export var callReservationTeam = "OffersPerPromo-module--call-reservation-team--c6f6d";
export var countdownContainer = "OffersPerPromo-module--countdown-container--d678c";
export var expiresOn = "OffersPerPromo-module--expires-on--7795a";